import axios from "axios";
import { serialize } from "@/util/util";
import errorCode from "@/const/errorCode";
import qs from "qs";
import store from "@/store";

import { $go_wx_auth_url } from "@/util/wxSdk";

axios.defaults.timeout = 30000;

// 返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};

// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

axios.get_token = function () {
  return store.getters.access_token;
};

// HTTP request拦截
axios.interceptors.request.use((req) => {
  var v4_token_mall = sessionStorage.getItem("budo.v4_token_mall")
  req.headers["Authorization"] = "Bearer " + v4_token_mall

  // headers中配置serialize为true开启序列化
  if (req.method === "post" && req.headers.serialize) {
    req.data = serialize(req.data);
    delete req.data.serialize;
  }

  if (req.method === "get") {
    req.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" });
    };
  }

  return req;
}, (error) => {
  budo_log.info("#41 interceptors.request.use", error);
  return Promise.reject(error);
});

// HTTP response拦截
axios.interceptors.response.use((res) => {
  const status = Number(res.status) || 200;
  const message = res.data.msg || errorCode[status] || errorCode["default"];
  const code = res.data.code

  if (status === 401 || -3 == code) {
    budo_log.debug("#49 response err 401", message, location, res);

    var redirectUrl = location.pathname + location.search + location.hash;
    $go_wx_auth_url(redirectUrl);

    return Promise.reject(new Error("error 401"));
  }

  return res.data;
}, (error) => {
  budo_log.debug("#60 interceptors.response.use", error);
  return Promise.reject(new Error(error));
}
);

axios.post_form = function (url, data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => formData.append(key, data[key]));
  return axios.post(url, formData);
};

export default axios;
